import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import SectionHeader from "../SectionHeader";
import "./style.scss";
import Button from "../Button";
import { useNavigate } from "react-router";
import bg from "./img/img.jpg";

const MyNiceModal = NiceModal.create(() => {
  const navigate = useNavigate();
  const modal = useModal();
  const handleClose = () => {
    modal.hide();
    navigate("/activities");
  };

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
        navigate("/activities");
      }}
      onAfterClose={() => modal.remove()}
      innerClass={"error-wheel-modal"}
    >
      <>
        <>
          <SectionHeader>
            <strong>Schalte das Glücksrad frei,</strong>
          </SectionHeader>
          <div className="content">
            <h2 className="subtitle">
              Kaufe jetzt eine glo Hyper Pro Crimson auf{" "}
              <strong>myglo.com</strong> um an dem Glücksrad drehen zu können*.
            </h2>
            <p className="copy">
              *Das Glücksrad wird innerhalb von 24 Stunden nach Abschluss der
              Transaktion freigeschaltet.
            </p>
          </div>
          <div className="buttons-wrapper">
            <Button
              action={() => {
                handleClose();
              }}
              btnClass="outline yellow"
            >
              Zurück zu den Aktivitäten
            </Button>
            <Button
              href={`${
                import.meta.env.VITE_DG_URL
              }/glo-heater/glo-hyper-pro-crimson-red/?utm_source=IC&utm_medium=Activity&utm_campaign=CRIMSON`}
              btnClass="yellow"
            >
              Weiter zum Online-Shop
            </Button>
          </div>
        </>
      </>
    </Modal>
  );
});

export default MyNiceModal;
